import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element, requiredModuleId, usuarioLogado }) => {
  const hasAccess = usuarioLogado.modulos?.some(
    (modulo) => modulo.id === requiredModuleId && modulo.ativo === true
  );

  return hasAccess ? element : <Navigate to="/nope" replace />;
};

export default PrivateRoute;
